module.exports = __webpack_public_path__ + "static/media/p10000.6beaf048.png";